package one.devsbox.www.ui.resources.detail

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import one.devsbox.www.provider.*
import one.devsbox.www.tools.ArgsId
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class ResourceCtx private constructor(
    val vm: ResourceVM,
    val nav: Navigation,
    val args: ArgsId,
    val overlay: OverlayProvider,
    val me: MeProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color,
    val colorErrorContainer: Color
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): ResourceCtx {
            val nav = LocalNavigation.current
            val overlay = LocalOverlayProvider.current
            val args = LocalNavigationArgs.current.args<ArgsId>()
            val vm = nav.viewModel(ResourceVM::class)
            val me = LocalMeProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primary
            val colorSecondary = MaterialTheme.colorScheme.secondary
            val colorError = MaterialTheme.colorScheme.error
            return remember(args.id) {
                ResourceCtx(
                    vm = vm,
                    nav = nav,
                    args = args,
                    overlay = overlay,
                    me = me,
                    colorPrimaryContainer = colorPrimary,
                    colorSecondaryContainer = colorSecondary,
                    colorErrorContainer = colorError
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }
}
